import React, { useEffect, useState, useRef } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../provider/AuthProvider";
import UseTitle from "../components/useTitle";
import "./Login.scss";

// Variables d'environnement pour l'URL de l'API
const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  // Définition du titre de la page
  UseTitle("Connexion");

  // Gestion du token d'authentification
  const { setToken, setTokenRefresh } = useAuth();

  const formLogin = useRef(); // Gère les élements du formulaire
  // Gestion du message d'erreur du formulaire
  const [messageError, setMessageError] = useState("");

  // Redirection vers une autre page
  const [redirectTo, setRedirectTo] = useState();

  // Création des JWTokens
  const handleLogin = (e) => {
    e.preventDefault(); // Empeche le rafraichissement de la page

    // Récuperation des éléments du formulaire pour la requête
    const formData = {
      username: formLogin.current[0].value,
      password: formLogin.current[1].value,
    };

    axios
      .post(`${API_URL}/auth/jwt/create/`, formData)
      .then((response) => {
        // Configuration des JWTokens
        setToken(response.data.access);
        setTokenRefresh(response.data.refresh);
        // Redirection vers la page d'accueil
        // TODO : choisir où rediriger
        setRedirectTo("/");
      })
      .catch((error) => {
        // Recuperation du message d'erreur
        const message = error.response.data;
        // Création du message d'erreur en fonction de l'erreur
        if (message.username) {
          setMessageError("Nom d'utilisateur : " + message.username[0]);
        } else if (message.password) {
          setMessageError("Mot de passe : " + message.password[0]);
        } else {
          setMessageError("Le nom d'utilisateur ou le mot de passe invalide");
        }
      });
  };

  useEffect(() => {
    formLogin.current[0].focus();
  }, [formLogin]);

  // Redirection vers une autre page choisie
  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="login">
        <h1>Connexion</h1>
        <form
          className="login-form"
          ref={formLogin}
          onSubmit={(e) => handleLogin(e)}
        >
          <div className="inputs">
            <input
              type="text"
              id="username"
              name="username"
              autoComplete="username"
              placeholder="nom d'utilisateur"
              defaultValue=""
              required
            />
            <input
              type="password"
              id="password"
              name="password"
              autoComplete="current-password"
              placeholder="mot de passe"
              defaultValue=""
              required
            />
          </div>
          <div className="submit">
            <button className="bt" type="submit">
              Connexion
            </button>
          </div>
        </form>
        {messageError && <span className="error">{messageError}</span>}
      </div>
    </>
  );
};

export default Login;
